import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1004622158627739';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
/**
 * Injects the official Meta (Facebook) Pixel base code and fires a PageView.
 * Renders nothing.
 */
export function MetaPixel() {
  useEffect(() => {
    // Avoid double-injection (e.g. React StrictMode / re-mounts)
    if (window.fbq) {
      window.fbq('track', 'PageView');
      return;
    }
    /* eslint-disable */
    ;
    (function (f: any, b: Document, e: string, v: string) {
      let n: any, t: HTMLScriptElement, s: HTMLScriptElement | null;
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e) as HTMLScriptElement;
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0] as HTMLScriptElement | null;
      // Safely insert: before an existing <script> if present, otherwise fall
      // back to <head>/<body> so it works in iframe/preview environments where
      // no <script> tag is reachable (s would be undefined).
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        ;
        (b.head || b.body || b.documentElement).appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
    // <noscript> fallback pixel
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`;
    img.alt = '';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, []);
  return null;
}